export default __webpack_public_path__ + "static/media/FUNCIONALIDADES_TOP_ICON.e434a045.svg";